import React, { useState, useEffect } from 'react';
import ReactPaginate from 'react-paginate';

const normalizePageCount = (pageCount) => {
    const count = Number(pageCount);
    if (!Number.isFinite(count) || count < 0) {
        return 0;
    }
    return Math.floor(count);
};

/**
 * Wrapper around react-paginate that handles responsiveness dynamically
 * and avoids console warnings when pageCount is 0 or forcePage is out of range.
 */
const SafeReactPaginate = ({ pageCount, forcePage, marginPagesDisplayed, pageRangeDisplayed, ...rest }) => {
    const safePageCount = normalizePageCount(pageCount);

    const [isMobile, setIsMobile] = useState(() => {
        return typeof window !== 'undefined' ? window.innerWidth < 768 : false;
    });

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (safePageCount <= 0) {
        return null;
    }

    // En móviles forzamos siempre 1 página en los extremos y 2 en el rango activo
    // evitando que props heredadas como marginPagesDisplayed=10 llenen la pantalla de botones
    const resolvedMarginPages = isMobile ? 1 : (marginPagesDisplayed ?? 2);
    const resolvedPageRange = isMobile ? 2 : (pageRangeDisplayed ?? 3);

    const paginateProps = {
        marginPagesDisplayed: resolvedMarginPages,
        pageRangeDisplayed: resolvedPageRange,
        ...rest,
        pageCount: safePageCount,
    };

    if (forcePage !== undefined && forcePage !== null) {
        const index = Number(forcePage);
        if (Number.isFinite(index)) {
            paginateProps.forcePage = Math.min(
                Math.max(Math.floor(index), 0),
                safePageCount - 1
            );
        }
    }

    return <ReactPaginate {...paginateProps} />;
};

export default SafeReactPaginate;
